<template>
  <div class="card">
    <h3 class="title">Mis Postulaciones</h3>
    <div class="filters">

      <v-row dense align="center">

        <v-col cols="12" sm="4" md="3">

          <v-select
            v-model="estadoFiltro"
            :items="listaEstados"
            label="Estado"
            clearable
            dense
            outlined
            :loading="loadingPostulaciones"
            :no-data-text="
              loadingPostulaciones
                ? 'Cargando...'
                : 'Sin resultados'
            "
          />

        </v-col>

        <template v-if="esAdmin">

          <v-col cols="12" sm="4" md="3">

            <v-select
              v-model="filtrosAdmin.proveedor"
              :items="listaProveedores"
              label="Proveedor"
              clearable
              dense
              outlined
              :loading="loadingPostulaciones"
              :no-data-text="
                loadingPostulaciones
                  ? 'Cargando...'
                  : 'Sin resultados'
              "
            />

          </v-col>

          <v-col cols="12" sm="4" md="3">

            <v-select
              v-model="filtrosAdmin.contratista"
              :items="listaContratistas"
              label="Contratista"
              clearable
              dense
              outlined
              :loading="loadingPostulaciones"
              :no-data-text="
                loadingPostulaciones
                  ? 'Cargando...'
                  : 'Sin resultados'
              "
            />

          </v-col>

        </template>

      </v-row>

    </div>
    <table class="table">
      <thead>
        <tr>
          <th>Requerimiento</th>
          <th>Fecha</th>
          <th>Estado</th>
          <th>Acción</th>
        </tr>
      </thead>

      <tbody>
        <!-- <tr v-for="item in postulaciones" :key="item.idrequerimiento"> -->
        <tr v-for="item in postulacionesFiltradas" :key="item.idrequerimiento">
          <td>
            <div class="job-mini">
              <div class="job-logo">
                <img :src="item.logo_empresa" alt="logo" />
              </div>

              <div class="job-info">
                <h3 class="job-title">
                  <strong>{{ item.denominacion.slice(0,3) }}</strong> - {{ nombreRubro(item.servicio) }} / {{ obtenerServiciosDetalle(item.detalles) }}
                </h3>

                <p class="job-company">
                  {{ item.empresa_contratista }}
                </p>

                <v-alert
                  v-if="esAdmin"
                  dense
                  text
                  color="#0095A9"
                  class="mb-4"
                >
                  Empresa postulante:
                  <strong>{{ item.nombre_empresa }}</strong>
                </v-alert>

                <div class="job-meta">
                  <span>📅 Publicado el {{ item.fecha_inicio.split('T')[0].split('-').reverse().join('/') }}</span>
                  <span>📅 Final {{ item.fecha_fin.split('T')[0].split('-').reverse().join('/') }}</span>
                </div>
              </div>
            </div>
          </td>
          <td>{{ item.fecha.split('-').reverse().join('/') }}</td>
          <td>
            <span class="badge" :class="estadoClass(item.estado)">
              {{ item.estado }}
            </span>
          </td>
          <td class="action-cell">
            <v-btn
              icon
              small
              @click="abrirModal(item)"
              :title="'Ver detalle'"
            >
              <v-icon color="primary">mdi-eye</v-icon>
            </v-btn>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Modal Confirmación -->
    <div v-if="showConfirm" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="icon-check"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#22c55e"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M20 6L9 17l-5-5" />
          </svg>
        </div>

        <h2 class="modal-title">¡Postulación Confirmada!</h2>

        <p class="modal-text">
          Tu postulación al requerimiento
          <span class="req-title">{{ postulacionActual.codigo }} - {{ postulacionActual.servicio }}</span>
          ha sido enviada correctamente y se encuentra en evaluación.
        </p>

        <button class="btn-accept" @click="showConfirm = false">
          Aceptar
        </button>
      </div>
    </div>

    <div v-if="showObservado" class="modal-overlay">
      <div class="modal-content result-modal">
        <div class="result-icon">❌</div>

        <p class="result-header">Resultado de Postulación</p>

        <h2 class="result-status-o">Observado</h2>

        <p class="result-motivo">
          <strong>Motivo:</strong> {{ postulacionActual.postulaciones }}{{ postulacionActual.comentario_empresa }}
        </p>

        <p class="result-observacion">
          <strong>Observación:</strong>
          {{ postulacionActual.tipo_respuesta }}
        </p>

        <button class="btn-accept" @click="showObservado= false">
          Aceptar
        </button>
      </div>
    </div>
    <!-- Modal Resultado No Adjudicado -->
    <div v-if="showResultado" class="modal-overlay">
      <div class="modal-content result-modal">
        <div class="result-icon">❌</div>

        <p class="result-header">Resultado de Postulación</p>

        <h2 class="result-status">No Adjudicado</h2>

        <p class="result-motivo">
          <strong>Motivo:</strong> {{ postulacionActual.postulaciones }}{{ postulacionActual.comentario_empresa }}
        </p>

        <p class="result-observacion">
          <strong>Observación:</strong>
          {{ postulacionActual.tipo_respuesta }}
        </p>

        <button class="btn-accept" @click="showResultado = false">
          Aceptar
        </button>
      </div>
    </div>

    <!-- MODAL ADJUDICADO (NUEVO, AISLADO) -->
    <div v-if="showAdjudicado" class="modal-overlay">
      <div class="adj-modal">
        <div class="adj-header">
          ¡Felicitaciones!
        </div>

        <div class="adj-body">
          <p class="adj-subtitle">Usted ha sido Adjudicado</p>

          <p class="adj-steps-title">Próximos Pasos:</p>

          <ul class="adj-steps">
            <li>✔ Firma de Contrato</li>
            <li>✔ Entrega de Documentos</li>
            <li>✔ Contacto con el Área Responsable</li>
          </ul>
        </div>

        <p class="result-motivo">
          <strong>Motivo:</strong> {{ postulacionActual.postulaciones }}{{ postulacionActual.comentario_empresa }}
        </p>

        <div class="adj-footer">
          <button class="adj-btn" @click="showAdjudicado = false">
            Aceptar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: 'MisPostulaciones',
  data() {
    return {
      showConfirm: false,
      showResultado: false,
      showAdjudicado: false,
      showObservado: false,
      postulaciones: [],
      empresa_item: [],
      postulacionActual: null,
      esAdmin: false,
      estadoFiltro: '',
      loadingPostulaciones: false,
      filtrosAdmin: {
        proveedor: null,
        contratista: null
      },
      // postulaciones: [
      //   {
      //     codigo: 'RQ-025',
      //     servicio: 'Mantenimiento',
      //     fecha: '10/03',
      //     estado: 'En Evaluación'
      //   },
      //   {
      //     codigo: 'RQ-020',
      //     servicio: 'Servicios de Catering',
      //     fecha: '01/02',
      //     estado: 'No Adjudicado'
      //   },
      //   {
      //     codigo: 'RQ-015',
      //     servicio: 'Alquiler de Camioneta',
      //     fecha: '15/01',
      //     estado: 'Adjudicado'
      //   }
      // ]
    }
  },
  async created(){
    this.idusuario = localStorage.getItem('idusuario')
    this.rol = localStorage.getItem('rol')
    this.empresaid = localStorage.getItem('empresa')
    this.empresaid = this.empresaid ? Number(this.empresaid) : null
    if (this.rol == 'ADMINISTRADOR')
      this.esAdmin = true;
    await this.cargarCategorias();
    await this.listarEmpresasContratistas();
    await this.listarPostulaciones();
  },
  mounted() {

  },
  computed: {
    postulacionesFiltradas() {

      return this.postulaciones.filter(item => {

        /*
        ESTADO (actual)
        */

        if (
          this.estadoFiltro &&
          item.estado !== this.estadoFiltro
        ) {
          return false
        }

        /*
        SOLO ADMIN
        */

        if (this.esAdmin) {

          if (
            this.filtrosAdmin.proveedor &&
            item.nombre_empresa !==
            this.filtrosAdmin.proveedor
          ) {
            return false
          }

          if (
            this.filtrosAdmin.contratista &&
            item.empresa_contratista !==
            this.filtrosAdmin.contratista
          ) {
            return false
          }

        }

        return true

      })

    },
    listaProveedores() {

      return [...new Set(

        this.postulaciones.map(
          p => p.nombre_empresa
        )

      )]
      .filter(Boolean)
      .sort()

    },

    listaContratistas() {

      return [...new Set(

        this.postulaciones.map(
          p => p.empresa_contratista
        )

      )]
      .filter(Boolean)
      .sort()

    },

    listaEstados() {

      return [...new Set(

        this.postulaciones.map(
          p => p.estado
        )

      )]
      .filter(Boolean)
      .sort()

    },
  },
  methods: {
    async listarPostulaciones() {
      this.loadingPostulaciones = true
      axios
        .get('api/PostulacionEmpresas/ListarPorEmpresa/' + this.idusuario)
        .then(res => {
          this.postulaciones = res.data.map(p => {
            const empresa = this.empresa_item.find(
              e => e.id_empresa_contratista === p.id_empresa_contratista
            )
            return {
              codigo: p.codigo,
              servicio: p.servicio,
              fecha: p.fecha? p.fecha.split('T')[0] : null,
              fecha_inicio: p.fecha_inicio,
              fecha_fin: p.fecha_fin,
              estado: p.estado,
              comentario_empresa: p.comentario_empresa,
              tipo_respuesta: p.tipo_respuesta,
              denominacion: p.denominacion,
              detalles: p.detalles,
              nombre_empresa: p.nombre_empresa,

              // 🔥 datos combinados
              empresa_contratista: empresa
                ? empresa.empresa_contratista
                : 'Sin empresa',

              logo_empresa: empresa
                ? empresa.logo_empresa
                : null
            }
          })
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          this.loadingPostulaciones = false
        });
    },
    async cargarCategorias() {
      try {
        const response = await axios.get("/api/CategoriaServicios/Listar");
        this.categorias_servicios = response.data;
      } catch (error) {
        console.error("Error cargando categorías:", error);
      }
    },
    nombreRubro (idRubro) {
      // console.log(this.categorias_servicios)
      const rubro = this.categorias_servicios.find(
        c => c.id === idRubro
      )
      return rubro ? rubro.nombrecategoria : '—'
    },
    abrirModal(item) {
      // Cerrar todos primero
      this.showConfirm = false
      this.showResultado = false
      this.showAdjudicado = false
      this.showObservado = false

      // Guardamos el item actual si lo necesitas
      this.postulacionActual = item

      switch (item.estado) {
        case 'REGISTRADO':
        case 'APROBADO_ADMIN':
        case 'EN_EVALUACIÓN':
          this.showConfirm = true
          break

        case 'OBSERVADO':
        case 'RECHAZADO_ADMIN':
          this.showObservado = true
          break

        case 'RECHAZADO':
        case 'NO ADJUDICADO':
        case 'NO_ADJUDICADO':
          this.showResultado = true
          break

        case 'ADJUDICADO':
          this.showAdjudicado = true
          break

        default:
          console.warn('Estado no manejado:', item.estado)
      }
    },

    estadoClass(estado) {
      return {
        'badge-evaluacion': estado === 'EN_EVALUACION' || estado === 'EN_EVALUACIÓN' || estado === 'REGISTRADO',
        'badge-no': estado === 'RECHAZADO' || estado === 'OBSERVADO' || estado === 'NO ADJUDICADO' || estado === 'NO_ADJUDICADO' || estado === 'RECHAZADO_ADMIN',
        'badge-si': estado === 'ADJUDICADO' || estado === 'APROBADO_ADMIN'
      }
    },
    async listarEmpresasContratistas() {
      let me = this;
      me.empresa_item=[];
      await axios
        .get("api/Contratistas/Listar")
        .then(function (response) {
          me.empresa_item = response.data;
          // console.log(me.empresa_item)
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    obtenerServiciosDetalle(detalles) {
      if (!detalles || !detalles.length) return 'Sin detalle';

      return detalles
        .map(d => d.servicio)
        .join(' / ');
    },
  }
}
</script>

<style scoped>
/* Card */
.card {
  background: #fff;
  border-radius: 6px;
  padding: 18px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.title {
  margin-bottom: 14px;
  font-size: 18px;
  font-weight: 600;
}

/* Tabla */
.table {
  width: 100%;
  border-collapse: collapse;
}

.table thead {
  background: #f3f4f6;
}

.table th,
.table td {
  padding: 16px 18px;
  text-align: left;
}

.table tbody tr {
  border-bottom: 1px solid #e5e7eb;
}

/* Requerimiento */
.req-text {
  font-weight: 600;
  padding-left: 12px;
}

.req-underline {
  width: 70px;
  height: 3px;
  background: #9ca3af;
  margin-left: 12px;
  margin-top: 6px;
}

/* Badges */
.badge {
  padding: 6px 12px;
  border-radius: 14px;
  font-size: 13px;
  font-weight: 600;
}

.badge-evaluacion {
  background: #fef9c3;
  color: #854d0e;
}

.badge-no {
  background: #fee2e2;
  color: #b91c1c;
}

.badge-si {
  background: #bbf7d0;
  color: #166534;
}

/* Botones */
.btn-container {
  margin-top: 20px;
  text-align: right;
}

.btn-confirm {
  background: #2563eb;
  color: white;
  padding: 10px 24px;
  border-radius: 6px;
  border: none;
  font-weight: 600;
  cursor: pointer;
}

.btn-secondary {
  margin-left: 10px;
  background: #6b7280;
  color: white;
  padding: 10px 24px;
  border-radius: 6px;
  border: none;
  font-weight: 600;
  cursor: pointer;
}

/* Botón nuevo */
.btn-adj {
  margin-left: 10px;
  background: #1e3a8a;
  color: white;
  padding: 10px 24px;
  border-radius: 6px;
  border: none;
  font-weight: 600;
  cursor: pointer;
}

/* Modal base */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  padding: 26px;
  border-radius: 12px;
  max-width: 400px;
  width: 90%;
  text-align: center;
}

/* Confirmación */
.icon-check {
  width: 56px;
  height: 56px;
}

.modal-title {
  color: #2563eb;
  margin: 14px 0;
}

/* Resultado */
.result-header {
  font-size: 14px;
  color: #6b7280;
}

.result-icon {
  font-size: 36px;
}

.result-status {
  color: #dc2626;
  font-size: 22px;
  margin: 10px 0;
}

.result-status-o {
  color: #facc15;
  font-size: 22px;
  margin: 10px 0;
}

.result-motivo,
.result-observacion {
  font-size: 14px;
  color: #374151;
  margin-bottom: 10px;
}

/* Botón aceptar */
.btn-accept {
  background: #2563eb;
  color: white;
  padding: 10px 28px;
  border-radius: 6px;
  border: none;
  font-weight: 600;
  cursor: pointer;
}

/* ===== MODAL ADJUDICADO (AISLADO) ===== */
.adj-modal {
  background: white;
  width: 420px;
  border-radius: 6px;
  overflow: hidden;
  text-align: center;
}

.adj-header {
  background: #2D8C9E;
  color: white;
  padding: 12px;
  font-weight: 700;
}

.adj-body {
  padding: 20px;
}

.adj-subtitle {
  color: #1e40af;
  font-weight: 600;
  margin-bottom: 16px;
}

.adj-steps-title {
  font-weight: 600;
  margin-bottom: 8px;
}

.adj-steps {
  text-align: left;
  padding-left: 20px;
  margin-bottom: 20px;
}

.adj-footer {
  padding-bottom: 18px;
}

.adj-btn {
  background: #2D8C9E;
  color: white;
  padding: 10px 26px;
  border-radius: 6px;
  border: none;
  font-weight: 600;
  cursor: pointer;
}
.req-title {
  font-weight: 600;
  font-size: 15px;
}
/* ====== FIX TABLA REQUERIMIENTO ====== */

/* Control de columnas */
.table th:nth-child(1),
.table td:nth-child(1) {
  width: 55%;
}

.table th:nth-child(2),
.table td:nth-child(2) {
  width: 15%;
}

.table th:nth-child(3),
.table td:nth-child(3) {
  width: 15%;
}

.table th:nth-child(4),
.table td:nth-child(4) {
  width: 15%;
  text-align: center;
}

/* Contenedor del requerimiento */
.job-mini {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 4px 0;
}

/* Logo */
.job-mini .job-logo {
  width: 100px;
  height: 100px;
  flex-shrink: 0;
}

.job-mini .job-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 50%;
}

/* Info */
.job-mini .job-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* Título */
.job-mini .job-title {
  font-size: 14px;
  font-weight: 600;
  margin: 0;
}

/* Empresa */
.job-mini .job-company {
  font-size: 12px;
  color: #6b7280;
}

/* Fechas */
.job-mini .job-meta {
  font-size: 11px;
  color: #6b7280;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
/* ===== Filtros ===== */
.filters{
  margin-bottom:12px;
}

/* ===== Tabla ===== */
.table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.table thead th {
  background: #f9fafb;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  border-bottom: 1px solid #e5e7eb;
}

.table tbody tr {
  transition: background 0.2s ease;
}

.table tbody tr:hover {
  background: #f9fafb;
}

.table td {
  vertical-align: top;
}

/* Acción */
.action-cell {
  text-align: center;
  vertical-align: middle;
}
.badge {
  display: inline-block;
  min-width: 110px;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
</style>
